import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";


export const getAllProcessMonitor = async () => {
    return (await api.get(
        `${apiRoutes.processMonitor.getAllProcess}`
    )).data;
};

export const getProcessMonitorById = async (id) => {
    return (await api.get(
        `${apiRoutes.processMonitor.base}/${id}`
    )).data;
};
